import { useEffect, useRef, useState } from 'react';

/** 목록 로딩이 너무 짧게 끝나도 스피너가 최소 이 시간(ms)은 보이게 함 */
export const MIN_LIST_LOADING_MS = 300;

/**
 * @param {boolean} busy 실제 요청 진행 중이면 true
 * @param {number} [minMs=MIN_LIST_LOADING_MS] 스피너 최소 표시 시간
 * @returns {boolean} 화면에 로딩 UI를 보일지
 */
export function useMinLoadingDisplay(busy, minMs = MIN_LIST_LOADING_MS) {
    const [show, setShow] = useState(!!busy);
    const startRef = useRef(null);
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (busy) {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
            startRef.current = Date.now();
            setShow(true);
            return () => {
                if (timeoutRef.current) {
                    clearTimeout(timeoutRef.current);
                    timeoutRef.current = null;
                }
            };
        }

        const started = startRef.current;
        startRef.current = null;

        if (started === null) {
            setShow(false);
            return;
        }

        const elapsed = Date.now() - started;
        const remaining = Math.max(0, minMs - elapsed);

        timeoutRef.current = setTimeout(() => {
            timeoutRef.current = null;
            setShow(false);
        }, remaining);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
                timeoutRef.current = null;
            }
        };
    }, [busy, minMs]);

    return show;
}
